(() => {
  if (!document.body.classList.contains('temp-products-bundle-landing')) return;

  const REBUY_ROOT_SELECTOR = '#rebuy-cart, .rebuy-cart, .rebuy-cart__flyout-recommendations, .rebuy-widget, [data-rebuy-id]';

  const PRODUCT_LINK_SELECTOR = [
    '#rebuy-cart a[href*="/products/"]',
    '.rebuy-cart a[href*="/products/"]',
    '#rebuy-cart a.rebuy-product-title-link',
    '#rebuy-cart a.rebuy-product-image',
    '.rebuy-cart a.rebuy-product-title-link',
    '.rebuy-cart a.rebuy-product-image',
    '.rebuy-cart__flyout-recommendations a.rebuy-product-title-link',
    '.rebuy-cart__flyout-recommendations a.rebuy-product-image',
    '.rebuy-widget a.rebuy-product-title-link',
    '.rebuy-widget a.rebuy-product-image',
    '.widget-type-cross-sell a.rebuy-product-title-link',
    '.widget-type-cross-sell a.rebuy-product-image',
  ].join(', ');

  const CLICK_BLOCK_SELECTOR = [
    '.rebuy-product-title-link',
    '.rebuy-product-image',
    '.rebuy-product-image-trigger',
  ].join(', ');

  const WATCH_TARGET_SELECTOR = '#rebuy-cart, .rebuy-cart, .rebuy-cart__flyout-recommendations, .rebuy-widget, [data-rebuy-id]';

  const disableProductLinks = () => {
    document.body.classList.add('lp-rebuy-cart--no-product-links');

    document.querySelectorAll(PRODUCT_LINK_SELECTOR).forEach((link) => {
      link.removeAttribute('href');
      link.classList.add('click-disabled');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
    });
  };

  const patchWidget = (widget) => {
    if (!widget || widget._lpDisableProductLinks) return;

    widget._lpDisableProductLinks = true;

    if (typeof widget.learnMore === 'function') {
      widget.learnMore = (_product, event) => {
        if (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        return false;
      };
    }

    if (typeof widget.hasLearnMore === 'function') {
      widget.hasLearnMore = () => false;
    }

    if (typeof widget.learnMoreURL === 'function') {
      widget.learnMoreURL = () => null;
    }

    disableProductLinks();
  };

  const patchAllWidgets = () => {
    window.Rebuy?.widgets?.forEach(patchWidget);
  };

  const patchSmartCart = () => {
    const smartCart = window.Rebuy?.SmartCart;
    if (!smartCart || smartCart._lpDisableProductLinks) return;

    smartCart._lpDisableProductLinks = true;

    if (typeof smartCart.isItemClickable === 'function') {
      smartCart.isItemClickable = () => false;
    }

    patchAllWidgets();
    disableProductLinks();
  };

  const onProductLinkClick = (event) => {
    const link = event.target.closest(CLICK_BLOCK_SELECTOR);
    if (!link || !link.closest(REBUY_ROOT_SELECTOR)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  };

  const onRebuyView = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
  };

  const watchRebuyTargets = () => {
    document.querySelectorAll(WATCH_TARGET_SELECTOR).forEach((target) => {
      if (target.dataset.lpProductLinksDisabled === 'true') return;

      target.dataset.lpProductLinksDisabled = 'true';

      const observer = new MutationObserver(disableProductLinks);
      observer.observe(target, { childList: true, subtree: true });
    });

    disableProductLinks();
  };

  const onWidgetLifecycle = (event) => {
    patchWidget(event.detail?.widget);
    watchRebuyTargets();
  };

  const init = () => {
    document.addEventListener('click', onProductLinkClick, true);
    document.addEventListener('rebuy.view', onRebuyView, true);
    document.addEventListener('rebuy.init', onWidgetLifecycle);
    document.addEventListener('rebuy.ready', onWidgetLifecycle);
    document.addEventListener('rebuy.productsChange', onWidgetLifecycle);
    document.addEventListener('rebuy.refresh', onWidgetLifecycle);
    document.addEventListener('rebuy:smartcart.ready', patchSmartCart);
    document.addEventListener('rebuy:smartcart.ready', watchRebuyTargets);
    document.addEventListener('rebuy:smartcart.show', () => {
      patchAllWidgets();
      disableProductLinks();
    });
    document.addEventListener('rebuy:cart.change', disableProductLinks);

    patchSmartCart();
    patchAllWidgets();
    watchRebuyTargets();

    document.addEventListener(
      'rebuy:smartcart.ready',
      () => {
        patchSmartCart();
        watchRebuyTargets();
      },
      { once: true }
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
